const reportTitles = ["downloads.final_report_2025", "downloads.final_report"];

export function redirectReportDownload(leaflet, language, router) {
  if (language !== "DE" || !reportTitles.includes(leaflet.text)) return false;
  router.push("/DE/downloads");
  return true;
}
